export interface PageMetadata {
  title: string;
  description: string;
  canonical: string;
  image?: string;
  keywords?: string[];
  noIndex?: boolean;
  structuredData?: unknown;
}

export function applyPageMetadata(metadata: PageMetadata): () => void {
  const previousTitle = document.title;
  document.querySelectorAll('script[data-static-metadata]').forEach((node) => node.remove());
  document.title = metadata.title;
  setMeta('description', metadata.description);
  if (metadata.keywords?.length) setMeta('keywords', metadata.keywords.join(', '));
  setMeta('author', '微言工具箱');
  setMeta('robots', metadata.noIndex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large');
  let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.append(canonical); }
  canonical.href = new URL(metadata.canonical, window.location.origin).toString();
  setMeta('og:title', metadata.title, 'property');
  setMeta('og:description', metadata.description, 'property');
  setMeta('og:url', canonical.href, 'property');
  setMeta('og:type', 'website', 'property');
  setMeta('og:site_name', '微言工具箱', 'property');
  setMeta('og:locale', 'zh_CN', 'property');
  setMeta('twitter:card', 'summary');
  setMeta('twitter:title', metadata.title);
  setMeta('twitter:description', metadata.description);
  if (metadata.image) {
    const image = new URL(metadata.image, window.location.origin).toString();
    setMeta('og:image', image, 'property');
    setMeta('og:image:alt', `${metadata.title}图标`, 'property');
    setMeta('twitter:image', image);
  }
  let script: HTMLScriptElement | null = null;
  if (metadata.structuredData) {
    script = document.createElement('script');
    script.dataset.pageMetadata = 'true';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(metadata.structuredData);
    document.head.append(script);
  }
  return () => { document.title = previousTitle; script?.remove(); };
}
function setMeta(name: string, content: string, key: 'name' | 'property' = 'name') {
  let node = document.querySelector<HTMLMetaElement>(`meta[${key}="${name}"]`);
  if (!node) { node = document.createElement('meta'); node.setAttribute(key, name); document.head.append(node); }
  node.content = content;
}
